import { NavLink, Outlet } from 'react-router-dom'
import './deployment.css'

const tabs = [
  { to: '/deployment/candidates', label: 'Candidate Review' },
  { to: '/deployment/comparisons', label: 'Comparisons' },
  { to: '/deployment/model-registry', label: 'Model Registry' },
  { to: '/deployment/events', label: 'Events' },
]

export default function DeploymentLayout() {
  return (
    <div className="deployment-page">
      <div className="deployment-toolbar" style={{ marginBottom: 18 }}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            style={({ isActive }) => ({
              display: 'inline-block',
              padding: '7px 12px',
              border: '1px solid #d9dee8',
              borderRadius: 6,
              background: isActive ? '#3949ab' : '#fff',
              color: isActive ? '#fff' : '#252b3a',
              textDecoration: 'none',
              fontSize: 13,
              fontWeight: isActive ? 700 : 500,
            })}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  )
}
